import Vue from 'vue'

/**
 * L'historique des actions : qui a fait quoi, au nom de qui, par où, et ce qui a changé. En GET, les filtres passent par
 * `data` (auth.fetch ignore `params`).
 */
class AuditTrailRepository {

  // GET /api/audit-trail/events - { items, hasMore, next }
  search(filters = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({ url: '/api/audit-trail/events', method: 'get', data: filters })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

  // GET /api/audit-trail/filters - { modules, objects, channels, outcomes }
  filters() {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({ url: '/api/audit-trail/filters', method: 'get' })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

  // GET /api/audit-trail/events/export - le CSV de la recherche, à télécharger
  export(filters = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({ url: '/api/audit-trail/events/export', method: 'get', data: filters, responseType: 'arraybuffer' })
        .then(response => resolve(window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }))))
        .catch(err => reject(err))
    })
  }
}

export default new AuditTrailRepository()
